/**
 * Mount / unmount Preact DockApp into the widget-manager chat dock slot.
 */

import { h, render } from 'preact'
import { createChatStore } from '../modules/chat/chat-store'
import { connectChatCable } from '../modules/chat/chat-cable'
import { configureChatApi } from '../modules/chat/chat-api'
import { DockApp } from '../modules/chat/components/DockApp'

/**
 * @param {HTMLElement} el
 * @param {{
 *   personId: number,
 *   personName: string,
 *   tenantId: string,
 *   canManageRooms: boolean,
 *   avatarUrl: string,
 *   unreadCount: number,
 * }} config
 */
export function mountChatDock(el, config) {
  if (!el || el.__chatDockMount) return el.__chatDockMount

  configureChatApi({
    tenantId: config.tenantId,
    personId: config.personId,
  })

  const store = createChatStore({
    roomId: null,
    personId: config.personId,
    personName: config.personName,
    tenantId: config.tenantId,
    canManageRooms: config.canManageRooms,
  })

  if (config.personId) {
    try {
      const key = `tsh:chatDock:${config.personId}.panels`
      const stored = localStorage.getItem(key)
      if (stored) {
        const parsed = JSON.parse(stored)
        if (Array.isArray(parsed) && parsed.length > 0) {
          store.floatPanels.value = parsed
        }
      }
    } catch { /* ignore */ }
  }

  const cable = connectChatCable({
    store,
    personId: config.personId,
    tenantId: config.tenantId,
  })

  const onOpenRoom = (event) => {
    const roomId = event.detail?.roomId
    if (!roomId) return
    const already = store.floatPanels.value.some((p) => p.roomId === roomId)
    if (!already) {
      store.floatPanels.value = [...store.floatPanels.value, { roomId, minimized: false }]
    } else {
      store.floatPanels.value = store.floatPanels.value.map((p) =>
        p.roomId === roomId ? { ...p, minimized: false } : p
      )
    }
  }
  window.addEventListener('chat:open-room', onOpenRoom)

  render(
    h(DockApp, {
      store,
      cable,
      personId: config.personId,
      personName: config.personName,
      avatarUrl: config.avatarUrl,
      unreadCount: config.unreadCount,
    }),
    el
  )

  const mount = {
    store,
    cable,
    unmount() {
      window.removeEventListener('chat:open-room', onOpenRoom)
      cable?.disconnect()
      render(null, el)
      delete el.__chatDockMount
    },
  }
  el.__chatDockMount = mount
  return mount
}

export function unmountChatDock(el) {
  el?.__chatDockMount?.unmount()
}
